/* eslint-disable react-hooks/exhaustive-deps */
import * as React from "react";
import {
  Table,
  TableBody,
  CircularProgress,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Box,
  Button,
  Grid,
  Typography,
} from "@mui/material";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { useTranslation } from "react-i18next";
import i18n from "../../i18";
import Nursery from "../Images/Nursery.png";
import PrimaryShool from "../Images/PrimaryShool.png";
import SecondarySchool from "../Images/SecondarySchool.png";

const GetTeacherReportMonth = () => {
  const { t } = useTranslation();
  const [dataSource, setDataSource] = React.useState([]);
  const [startDate, setStartDate] = React.useState(null);
  const [endDate, setEndDate] = React.useState(null);
  const token = localStorage.getItem("token");
  const [loading, setLoading] = React.useState(true);
  const [selectedImage, setSelectedImage] = React.useState(Nursery);
  const user = JSON.parse(localStorage.getItem("user"));
  const isRTL = i18n.language === 'ar' || i18n.language === 'ku';

  React.useEffect(() => {
    const loadUserData = () => {
      const branchId = user?.branch_id || 2;
      const branchImages = {
        1: Nursery,
        2: PrimaryShool,
        3: SecondarySchool,
      };
      setSelectedImage(branchImages[branchId] || Nursery);
    };

    loadUserData();
  }, [user]);
  const branchTitleMap = {
    1: "باخچەی منداڵانی کلیڤەری ناحکومی",
    2: "ناوەندیی کلیڤەری ناحکومی",
    3: "ئامادەی کلیڤەری ناحکومی",
  };
  const branchTitle =
    branchTitleMap[user?.branch_id] || "قوتابخانەی کلیڤەری بنەڕەتی ناحکومی";
  // Print styles with large font sizes (same as GetStudentReport)
  const printStyles = `
@media print {
     * {
        font-size: 24px !important;
      }
      
     html, body, div, span, table, tr, td, th, p, h1, h2, h3, h4, h5, h6 {
        font-size: 24px !important;
      }
      
     body, html {
        width: 100% !important;
        height: auto !important;
        margin: 0 !important;
        padding: 0 !important;
        font-size: 24px !important;
        line-height: 1.5 !important;
        -webkit-print-color-adjust: exact !important;
        print-color-adjust: exact !important;
        background-color: white !important;
        direction: ${isRTL ? 'rtl' : 'ltr'} !important;
        text-align: ${isRTL ? 'right' : 'left'} !important;
      }

    body * {
      visibility: hidden;
      font-size: 24px !important;
    }

    .print-container, .print-container * {
      visibility: visible;
      background-color: white !important;
      font-size: 24px !important;
      direction: ${isRTL ? 'rtl' : 'ltr'} !important;
      text-align: ${isRTL ? 'right' : 'left'} !important;
    }

    .print-container {
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: auto;
      padding: 0;
      margin: 0;
    }

    .print-header {
      display: block !important;
      text-align: ${isRTL ? 'right' : 'center'};
      margin-bottom: 20px;
      page-break-after: avoid;
      font-size: 24px !important;
      direction: ${isRTL ? 'rtl' : 'ltr'} !important;
    }

    .print-title {
      font-size: 32px !important;
      font-weight: bold !important;
      color: #333 !important;
      margin: 20px 0 !important;
    }

    .no-print {
      display: none !important;
    }

    .table-container {
      width: 100% !important;
      margin: 0 !important;
      overflow: visible !important;
      page-break-inside: auto;
    }

    table {
      width: 100% !important;
      border-collapse: separate !important;
      border-spacing: 0 !important;
      font-size: 24px !important;
      border: none !important;
      box-shadow: 0 1px 3px rgba(0,0,0,0.1) !important;
      border-radius: 8px !important;
      overflow: hidden !important;
      direction: ${isRTL ? 'rtl' : 'ltr'} !important;
    }

    th {
      background: #000080 !important;
      color: #ffffff !important;
      font-weight: 700 !important;
      font-size: 20px !important;
      text-align: ${isRTL ? 'right' : 'center'} !important;
      text-transform: uppercase !important;
      letter-spacing: 0.8px !important;
      border-bottom: 2px solid #dee2e6 !important;
      position: relative !important;
    }
    th, th * {
      background: #000080 !important;
      color: #ffffff !important;
      font-size: 20px !important;
    }
    th:first-child {
      border-top-left-radius: 8px !important;
    }
    th:last-child {
      border-top-right-radius: 8px !important;
    }
    thead {
      display: table-header-group !important;
    }
    tbody tr:nth-child(even) {
      background-color: #fafbfc !important;
    }
    tbody tr:nth-child(odd) {
      background-color: white !important;
    }
    tbody tr:hover {
      background-color: #f8f9fa !important;
      transform: translateY(-1px) !important;
      box-shadow: 0 2px 8px rgba(0,0,0,0.08) !important;
    }
    .total-row {
      background: #ffffff !important;
      color: #2c3e50 !important;
      font-weight: 700 !important;
      border-bottom: none !important;
      position: relative !important;
    }
    .total-row::before {
      content: '' !important;
      position: absolute !important;
      top: 0 !important;
      left: 0 !important;
      right: 0 !important;
      height: 3px !important;
    }
    .total-row td {
      background: transparent !important;
      color: #2c3e50 !important;
      font-weight: 700 !important;
      font-size: 24px !important;
      border: none !important;
      padding: 20px !important;
      text-align: ${isRTL ? 'right' : 'left'} !important;
      direction: ${isRTL ? 'rtl' : 'ltr'} !important;
    }
    .total-row td:first-child {
      border-bottom-left-radius: 8px !important;
    }
    .total-row td:last-child {
      border-bottom-right-radius: 8px !important;
    }
    @page {
      size: A4;
      margin: 8mm;
    }
    .print-container th,
    .print-container th * {
      font-size: 20px !important;
      background: #000080 !important;
      color: #ffffff !important;
    }
    .print-container td,
    .print-container td * {
      font-size: 24px !important;
    }
    .print-container table {
      font-size: 24px !important;
    }
    .print-container table td {
      font-size: 24px !important;
    }
    .print-container table th {
      font-size: 20px !important;
    }

    tr {
      page-break-inside: avoid;
      page-break-after: auto;
    }

    td, th {
      padding: 16px 20px !important;
      border: none !important;
      font-size: 24px !important;
      text-align: ${isRTL ? 'right' : 'left'} !important;
      vertical-align: middle !important;
      border-bottom: 1px solid #f0f0f0 !important;
      direction: ${isRTL ? 'rtl' : 'ltr'} !important;
    }
    td {
      font-size: 24px !important;
    }
    .print-container td, .print-container th {
      font-size: 24px !important;
    }
    .print-container th {
      font-size: 20px !important;
    }
  }

  .print-header {
    display: none;
  }
`;

  const handlePrint = () => {
    window.print();
  };

  const getCurrentAcademicYear = () => {
    const currentYear = new Date().getFullYear();
    return `${currentYear}-${currentYear + 1}`;
  };

  React.useEffect(() => {
    getApiProducts();
  }, [token]);

  const getApiProducts = async () => {
    try {
      const res = await fetch(
        "https://api.clever-school.com/api/reports/teachers-salary-report",
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );

      if (!res.ok) throw new Error(`HTTP error! Status: ${res.status}`);

      const responseData = await res.json();
      setDataSource(responseData.salaries || []);
    } catch (error) {
      console.error("Error fetching data:", error);
    } finally {
      setLoading(false);
    }
  };

  // Normalize date from state (may be dayjs from MUI DatePicker) to native Date
  const toNativeDate = (value) => {
    if (value == null) return null;
    if (value instanceof Date) return Number.isNaN(value.getTime()) ? null : value;
    if (typeof value.toDate === "function") return value.toDate();
    const d = new Date(value);
    return Number.isNaN(d.getTime()) ? null : d;
  };

  // Filter by month: start month included (from 1st), end month excluded
  const filteredData = dataSource.filter((row) => {
    const rowDate = new Date(row.salary_month);
    const startD = toNativeDate(startDate);
    const endD = toNativeDate(endDate);
    const fromStart =
      !startD ||
      rowDate >= new Date(startD.getFullYear(), startD.getMonth(), 1);
    const beforeEnd =
      !endD ||
      rowDate < new Date(endD.getFullYear(), endD.getMonth(), 1);
    return fromStart && beforeEnd;
  });

  const columns = [
    {
      title: t("serialNumber"),
      render: (_, __, index) => index + 1,
    },
    {
      title: t("name"),
      render: (_, row) => row.teacher?.name || t("notAvailable"),
    },
    {
      title: t("phoneNumber"),
      render: (_, row) => row.teacher?.phone_number || t("notAvailable"),
    },
    {
      title: t("baseSalary"),
      render: (_, row) =>
        parseFloat(row.teacher?.base_salary || 0).toLocaleString("en-US"),
    },
    {
      title: t("deductions"),
      render: (_, row) =>
        parseFloat(row.deduction || 0).toLocaleString("en-US"),
    },
    {
      title: t("additions"),
      render: (_, row) => {
        const addition = parseFloat(row.addition || 0);
        const lecturesCount = parseFloat(row.lectures_count || 0);
        return (addition * lecturesCount).toLocaleString("en-US");
      },
    },
    {
      title: t("finalSalary"),
      render: (_, row) =>
        parseFloat(row.final_salary || 0).toLocaleString("en-US"),
    },
    {
      title: t("salaryMonth"),
      dataIndex: "salary_month",
    },
    {
      title: t("reason"),
      dataIndex: "reason",
    },
  ];

  const totals = filteredData.reduce(
    (acc, row) => {
      const addition = parseFloat(row.addition || 0);
      const lecturesCount = parseFloat(row.lectures_count || 0);
      const additionTotal = addition * lecturesCount;

      return {
        baseSalary: acc.baseSalary + parseFloat(row.teacher?.base_salary || 0),
        deduction: acc.deduction + parseFloat(row.deduction || 0),
        addition: acc.addition + additionTotal,
        finalSalary: acc.finalSalary + parseFloat(row.final_salary || 0),
        baseLectures:
          acc.baseLectures + parseFloat(row.teacher?.base_lectures_count || 0),
        actualLectures: acc.actualLectures + lecturesCount,
      };
    },
    {
      baseSalary: 0,
      deduction: 0,
      addition: 0,
      finalSalary: 0,
      baseLectures: 0,
      actualLectures: 0,
    }
  );

  if (loading) {
    return (
      <Box
        sx={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          height: "100vh",
        }}
      >
        <CircularProgress size={60} />
      </Box>
    );
  }
  return (
    <LocalizationProvider dateAdapter={AdapterDayjs}>
      <style>{printStyles}</style>
      <Box 
        className="print-container"
        sx={{ 
          direction: isRTL ? "rtl" : "ltr", 
          textAlign: isRTL ? "right" : "left",
          padding: 2, 
          marginBottom: 17 
        }}
      >
        {/* Print Header */}
        <Box className="print-header">
          <Box sx={{ display: "flex", alignItems: "center", justifyContent: "center", mb: 2 }}>
            <img 
              src={selectedImage} 
              alt="School Logo" 
              style={{ 
                width: "80px", 
                height: "80px", 
                marginRight: isRTL ? "0" : "20px",
                marginLeft: isRTL ? "20px" : "0"
              }} 
            />
            <Box>
              <Typography variant="h4" className="print-title" sx={{ fontSize: "32px", fontWeight: "bold", color: "#333" }}>
                {branchTitle}
              </Typography>
              <Typography variant="h6" sx={{ fontSize: "20px", color: "#666", mt: 1 }}>
                {t("teacherSalaryReport")} - {getCurrentAcademicYear()}
              </Typography>
            </Box>
          </Box>
        </Box>

        {/* Filters and Print Button */}
        <Grid container spacing={2} mb={2} className="no-print">
          <Grid item xs={12} sm={4}>
            <DatePicker
              label={t("startDate")}
              views={["year", "month"]}
              value={startDate}
              onChange={(newValue) => setStartDate(newValue)}
              sx={{
                width: "100%",
                "& .MuiInputLabel-root": {
                  width: "100%",
                  textAlign: "center",
                  "&.Mui-focused": {
                    color: "inherit",
                  },
                },
              }}
              slotProps={{ textField: { size: "small" } }}
            />
          </Grid>
          <Grid item xs={12} sm={4}>
            <DatePicker
              label={t("endDate")}
              views={["year", "month"]}
              value={endDate}
              onChange={(newValue) => setEndDate(newValue)}
              sx={{
                width: "100%",
                "& .MuiInputLabel-root": {
                  width: "100%",
                  textAlign: "center",
                  "&.Mui-focused": {
                    color: "inherit",
                  },
                },
              }}
              slotProps={{ textField: { size: "small" } }}
            />
          </Grid>
          <Grid item xs={12} sm={4}>
            <Button
              variant="contained"
              onClick={handlePrint}
              sx={{
                width: "100%",
                height: 40,
                fontWeight: "bold",
                backgroundColor: "#2e7d32",
                "&:hover": { backgroundColor: "#1b5e20" },
              }}
            >
              {t("Print")}
            </Button>
          </Grid>
        </Grid>


        {/* Table */}
        <TableContainer
          component={Paper}
          sx={{
            borderRadius: 2,
            boxShadow: 3,
            marginBottom: 12,
            overflow: "auto",
            maxHeight: "70vh",
            "@media print": {
              boxShadow: "none",
              border: "1px solid #ddd",
              pageBreakInside: "auto",
            },
          }}
          className="table-container"
        >
          <Table 
            sx={{ 
              direction: isRTL ? "rtl" : "ltr",
              "& .MuiTableCell-root": {
                border: "none",
                fontSize: "16px",
                padding: "12px 16px",
              }
            }}
          >
            <TableHead>
              <TableRow>
                {columns.map((column) => (
                  <TableCell
                    key={column.dataIndex || column.title}
                    sx={{
                      backgroundColor: "#000080",
                      color: "#ffffff",
                      textAlign: isRTL ? "right" : "center",
                      fontSize: "18px",
                      fontWeight: 700,
                      textTransform: "uppercase",
                      letterSpacing: "0.8px"
                    }}
                  >
                    {column.title}
                  </TableCell>
                ))}
              </TableRow>
            </TableHead>
            <TableBody>
              {filteredData.map((row, index) => (
                <TableRow
                  key={row.id}
                  hover
                  sx={{ 
                    "&:last-child td": { borderBottom: 0 },
                    backgroundColor: index % 2 === 0 ? "#fafbfc" : "#ffffff",
                    "&:hover": {
                      backgroundColor: "#f8f9fa",
                      transform: "translateY(-1px)",
                      boxShadow: "0 2px 8px rgba(0,0,0,0.08)"
                    },
                    transition: "all 0.2s ease-in-out"
                  }}
                >
                  {columns.map((column) => (
                    <TableCell
                      key={column.dataIndex || column.title}
                      sx={{
                        textAlign: isRTL ? "right" : "left",
                        fontSize: "16px",
                        padding: "12px 16px",
                        borderBottom: "1px solid #f0f0f0",
                        "@media print": {
                          padding: "6px !important",
                        },
                      }}
                    >
                      {column.render
                        ? column.render(row[column.dataIndex], row, index)
                        : row[column.dataIndex]}
                    </TableCell>
                  ))}
                </TableRow>
              ))}

              {/* Total Row */}
              <TableRow 
                className="total-row"
                sx={{
                  backgroundColor: "#ffffff",
                  "@media print": {
                    backgroundColor: "#ffffff !important",
                  },
                }}
              >
                <TableCell
                  colSpan={3}
                  align="right"
                  sx={{
                    background: "#ffffff",
                    color: "#2c3e50",
                    fontWeight: 700,
                    fontSize: "20px",
                    padding: "20px",
                    border: "none",
                    position: "relative",
                    textAlign: isRTL ? "right" : "left",
                    "@media print": {
                      background: "#ffffff !important",
                      color: "#2c3e50 !important",
                      border: "none !important",
                      fontSize: "24px !important",
                    },
                  }}
                >
                  {t("total")}
                </TableCell>
                <TableCell 
                  sx={{
                    background: "#ffffff",
                    color: "#2c3e50",
                    fontWeight: 700,
                    fontSize: "20px",
                    padding: "20px",
                    border: "none",
                    position: "relative",
                    textAlign: isRTL ? "right" : "left",
                    "@media print": {
                      background: "#ffffff !important",
                      color: "#2c3e50 !important",
                      border: "none !important",
                      fontSize: "24px !important",
                    },
                  }}
                >
                  {totals.baseSalary.toLocaleString("en-US")}
                </TableCell>
                <TableCell 
                  sx={{
                    background: "#ffffff",
                    color: "#2c3e50",
                    fontWeight: 700,
                    fontSize: "20px",
                    padding: "20px",
                    border: "none",
                    position: "relative",
                    textAlign: isRTL ? "right" : "left",
                    "@media print": {
                      background: "#ffffff !important",
                      color: "#2c3e50 !important",
                      border: "none !important",
                      fontSize: "24px !important",
                    },
                  }}
                >
                  {totals.deduction.toLocaleString("en-US")}
                </TableCell>
                <TableCell 
                  sx={{
                    background: "#ffffff",
                    color: "#2c3e50",
                    fontWeight: 700,
                    fontSize: "20px",
                    padding: "20px",
                    border: "none",
                    position: "relative",
                    textAlign: isRTL ? "right" : "left",
                    "@media print": {
                      background: "#ffffff !important",
                      color: "#2c3e50 !important",
                      border: "none !important",
                      fontSize: "24px !important",
                    },
                  }}
                >
                  {totals.addition.toLocaleString("en-US")}
                </TableCell>
                <TableCell 
                  sx={{
                    background: "#ffffff",
                    color: "#2c3e50",
                    fontWeight: 700,
                    fontSize: "20px",
                    padding: "20px",
                    border: "none",
                    position: "relative",
                    textAlign: isRTL ? "right" : "left",
                    "@media print": {
                      background: "#ffffff !important",
                      color: "#2c3e50 !important",
                      border: "none !important",
                      fontSize: "24px !important",
                    },
                  }}
                >
                  {totals.finalSalary.toLocaleString("en-US")}
                </TableCell>
                <TableCell colSpan={2} />
              </TableRow>
            </TableBody>
          </Table>
        </TableContainer>
      </Box>
    </LocalizationProvider>
  );
};

export default GetTeacherReportMonth;
